import React from "react";
import Izvestaji from "../../components/admin/izvestaji";

function IzvestajiPage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <Izvestaji />
    </div>
  );
}

export default IzvestajiPage;
